<template>
  <tr class="test-result-row" :data-nutrient="item.type">
    <td class="nutrient">
      <div class="as-default">
        {{ item.type }}
      </div>
    </td>
    <td>
      <slidebar
        @input="setInterpretation"
        :value="warningLvl()"
        :max="max"
        :min="min"
        :marks="true"
        :data="['None', 'Low', 'Adequate', 'High', 'Excessive']"
        :hide-marks-label="true"
        :tooltip="'none'"
      >

      </slidebar>
    </td>
  </tr>
</template>

<script>
import { NutrientConverter } from '@/mixins/nutrient-converter.mixin';
import { UnitConverter } from '@/mixins/unit-converter.mixin';

export default {
  mixins: [ NutrientConverter, UnitConverter  ],
  props: {
    min: 0,
    max: 4,
    item: {

    }
  },
  data() {
    return {
      // interpretation: 0,
      // selected: null,
      unit: 'ppm'
    }
  },
  methods: {
    setInterpretation (val) {
      console.log(this.extension)
      if (this.extension) {
        if (val == 'None') {
          this.item.value = 0;
        } else if (val == 'Low') {
          this.item.value = this.extension.lowNum / 2;
        } else if (val == 'Adequate') {
          this.item.value = (this.extension.lowNum + this.extension.adequateNum) / 2;
        } else if (val == 'High') {
          this.item.value = (this.extension.adequateNum + this.extension.highNum) / 2;
        } else if (val == 'Excessive') {
          this.item.value = this.extension.highNum * 1.5;
        }
      }

      if(this.item.n_form) {
        this.$store.commit('tests/soil/computeN', this.item.n_form);
      }
    },
    warningLvl() {
      var lvl = this.$store.getters['tests/soil/getWarningLevel'](this.item.value, this.item.ext);
      var val = this.$store.getters['tests/soil/renderWarningLevel'](lvl);

      return val;
    },
  },
  computed: {
    extensions() {
      var ext;
      if (this.item.n_form) {
        ext = this.$store.getters['tests/soil/getGetExtsByNutrient']('N');
      } else {
        ext = this.$store.getters['tests/soil/getGetExtsByNutrient'](this.item.type);
      }
      return ext;
    },
    origin() {
      var nut;
      if (this.item.n_form) {
        nut = this.$store.getters['nutrients/data'].find(item => item.key == 'N');
      } else {
        nut = this.$store.getters['nutrients/data'].find(item => item.key == this.item.type);
      }
      return nut;
    },
    extension () {
      return this.extensions.find(item => {
        var temp1 = item.name.replace(/ /g, '');
        var temp2 = this.origin.defaultExtension.replace(/ /g, '');
        return temp1.toLowerCase() == temp2.toLowerCase();
      });
    },
  },
  created() {
    this.item.ext = 0;
    if (this.extension) {
      this.item.ext = this.extension.id;
    }
  },
  watch: {
    'item.value': function (val) {
      this.item.interpretation = this.warningLvl();
    }
  }
}
</script>

<style lang="scss" scoped>

.test-result-row {
  td {
    padding: 10px;
    &.nutrient {
      width: 120px;
      .app-sel {
        // padding-left: 0;
      }

      .as-default {
        // padding-left: 17px;
      }
    }

    .extentions {
      width: 100%;
    }

    &.warning-level {
      &.low {
        color: #5EC19B;
        font-weight: bold;
      }
      &.adequate {
        color: #A7B975;
        font-weight: bold;
      }
      &.high {
        color: #F2B14E;
        font-weight: bold;
      }
      &.excessive {
        color: #EC5A60;
        font-weight: bold;
      }
    }
  }
}

</style>
